import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'
import Toolbar from '@mui/material/Toolbar'
import useMediaQuery from '@mui/material/useMediaQuery'
import * as React from 'react'

import { useCognitoUser } from '../context/CognitoContext'
import EnvironmentBanner from './EnvironmentBanner'
import PageHeader from './PageHeader'
import PageSidebar from './PageSidebar'
// import SitemarkIcon from './SitemarkIcon';

export default function PageLayout({ children }: { children: React.ReactNode }) {
  const { cognitoUser, signOut } = useCognitoUser()
  const theme = useTheme()

  const [isDesktopNavigationExpanded, setIsDesktopNavigationExpanded] = React.useState(true)
  const [isMobileNavigationExpanded, setIsMobileNavigationExpanded] = React.useState(false)

  const isOverMdViewport = useMediaQuery(theme.breakpoints.up('md'))

  const isNavigationExpanded = isOverMdViewport ? isDesktopNavigationExpanded : isMobileNavigationExpanded

  const setIsNavigationExpanded = React.useCallback(
    (newExpanded: boolean) => {
      if (isOverMdViewport) {
        setIsDesktopNavigationExpanded(newExpanded)
      } else {
        setIsMobileNavigationExpanded(newExpanded)
      }
    },
    [isOverMdViewport]
  )

  const handleToggleHeaderMenu = React.useCallback(
    (isExpanded: boolean) => {
      setIsNavigationExpanded(isExpanded)
    },
    [setIsNavigationExpanded]
  )

  const layoutRef = React.useRef<HTMLDivElement>(null)

  return (
    <Box
      ref={layoutRef}
      sx={{
        position: 'relative',
        display: 'flex',
        overflow: 'hidden',
        height: '100%',
        width: '100%',
      }}
    >
      <EnvironmentBanner />
      <PageHeader
        logo={<img src="/vehoLogo.svg" alt="Veho Logo" width={32} height={32} />}
        title="Driver Payments"
        menuOpen={isNavigationExpanded}
        onToggleMenu={handleToggleHeaderMenu}
        cognitoUser={cognitoUser ?? undefined}
        onSignOut={signOut}
      />
      <PageSidebar
        expanded={isNavigationExpanded}
        setExpanded={setIsNavigationExpanded}
        container={layoutRef?.current ?? undefined}
      />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          minWidth: 0,
        }}
      >
        <Toolbar sx={{ displayPrint: 'none' }} />
        <Box
          component="main"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            minHeight: 0,
            overflow: 'auto',
          }}
          id="page-content-inner"
        >
          {children}
        </Box>
      </Box>
    </Box>
  )
}
